export const enum DashSearchDateType {
    RegistrationDate     = 0,
    IntakeCompleteDate   = 1,
    DonationDate         = 2,
}

export const enum DashCannedResponseType {
    General             = 0,
    DonorFollowUpSurvey = 1,
}

export const enum DashLabsStatus {
    NotOrdered     = 0,
    Ordered        = 1,
    Received       = 2,
}

export const enum DashIntakeStatus {
    Incomplete = 0,
    Referred   = 1,
    Donated    = 2,
    RuledOut   = 3
}